/* eslint-disable no-underscore-dangle */
import { component } from 'picoapp';

export default component(async (node) => {
  node.addEventListener('click', (event) => {
    event.preventDefault();

    window._dixa_?.invoke('setWidgetOpen', true);
  });
});
